import type { TOC } from '@ember/component/template-only'
import { LayoutBlocksConfirmModal } from 'teacher-ui-client/components/layout-blocks/confirm-modal'
import { t } from 'ember-intl'

interface Args {
  visible: boolean
  cancel: () => unknown
  confirm: () => unknown
}

export const StudentImportPrompt: TOC<Args> = <template>
  <LayoutBlocksConfirmModal
    @title={{t "manage.rollover.steps.students.importPrompt.title"}}
    @showModal={{@visible}}
    @cancel={{@cancel}}
    @cancelButtonText={{t "cancel"}}
    @confirm={{@confirm}}
    @confirmButtonText={{t "manage.rollover.steps.students.importPrompt.submit"}}
    @isSubmitting={{false}}
  >
    <div class="m-2 text-xl" data-test-rollover-import-prompt>
      <p>{{t "manage.rollover.steps.students.importPrompt.areYouSure"}}</p>
    </div>
  </LayoutBlocksConfirmModal>
</template>

export default StudentImportPrompt
